import { ApplicationUser, DevelopmentInput, DevelopmentInputClient } from "@src/apis/ModularClient";

export class DevelopmentInputController {
  selectedSection: string;

  objects: DevelopmentInput[];
  selectedObject: DevelopmentInput = {} as DevelopmentInput;

  fetchingObjects: boolean;
  fetchingObject: boolean;

  userRecords: ApplicationUser[];

  DevelopmentInputForm: ng.IFormController;
  //subDevelopmentInputForm: ng.IFormController;

  static $inject = ["$routeParams", "DevelopmentInputClient"];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private developmentInputClient: DevelopmentInputClient,
  ) {
    //Is search related to a saved search?

    if (this.$routeParams.searchId) {
      this.developmentInputClient.fetch(parseInt(this.$routeParams.searchId)).then((object) => {
        this.selectedObject = object;
      });
    } else {
      //Unsaved search. Use $rootScope
    }
  }

  save() {
    this.developmentInputClient.addUpdateReturnOnlyID(this.selectedObject).then((response) => {
      this.selectedObject.id = response;
      if (!this.objects) {
        this.objects = [];
      }

      let matches: DevelopmentInput[] = this.objects.filter((value, index) => {
        return value.id == response;
      });

      if (!matches || matches.length === 0) {
        this.objects.push(this.selectedObject);
      }

      this.DevelopmentInputForm.$setPristine();
    });
  }

  delete() {
    this.developmentInputClient.markAsDeleted(this.selectedObject.id).then((response) => {
      if (response) {
        this.objects.splice(this.objects.indexOf(this.selectedObject), 1);
        this.DevelopmentInputForm.$setPristine();
        delete this.selectedObject;
      }
    });
  }
}
